import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { QuestionType } from '@empathy/survey/base';

import { NotepadQuestionTypeConfig } from '../../models/notepad-question-type-config.constant';

@Component({
  selector: 'empathy-flags-form',
  templateUrl: './flags-form.component.html',
  styleUrl: './flags-form.component.scss'
})
export class FlagsFormComponent {
  @Input() disabled: boolean;
  @Input({ required: true }) question!: AbstractControl;
  @Input({ required: true }) questionType!: QuestionType;

  questionTypeConfig = NotepadQuestionTypeConfig;
}
